/**
 * How an environment reads in the picker.
 *
 * An environment normally shows its own name plus how many apps it holds, which
 * is what the viewer is choosing between. An environment that carries a `label`
 * shows that instead, with no count: the demo's `test` environment is the only
 * one today, where the count is an artifact of injecting the mock apps rather
 * than anything the viewer can act on.
 *
 * The name is never changed, only how it is displayed. It is what URLs and API
 * calls filter on.
 */
export function environmentLabel(env) {
  if (!env) return '';
  if (env.label) return env.label;
  return env.app_count > 0 ? `${env.name} (${env.app_count})` : env.name;
}
